import React from "react";



const AboutMessage = () =>{
    return(
        <div>
            <div className="card">
                <div>
                    <div className="card-title">
                        <p>About Us</p>
                    </div>
                </div>
                <div className="card-content">
                    <p className="flow-text">
                        We are a family owned contruction company located in Las Vegas Nevada.
                        With over thirty years of combined experience we can handle any size job, 
                        anything from pouring concrete and remodeling to home renovation.
                        If you have any questions need a quote to give us a call free of charge at 
                        702-366-4826, or send us an email at Progressconcrete@gmail.com.
                    </p>
                </div>

                <div className="card-action">
                    <p class = "orange-text">Phone: 702-366-4826 </p>
                    <p class = "orange-text">Email: <a>Progressconcrete@gmail.com</a></p>

                    <p class = "orange-text">Contractor Licence Number : 00-00-00-00</p>
                </div>
            </div>

        </div>
    );
}
export default AboutMessage;
